import { Outlet, RouteObject } from "react-router-dom";
import DashboardRoute from "./dashboard";
import FormsRoute from "./forms";
const StandaloneRoute: RouteObject = {
    path: "standalone",
    element: <Outlet />,
    children: [DashboardRoute, FormsRoute]
};
export default StandaloneRoute;
